// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1u7-G","info":"Note_info__23TqV","note":"Note_note__1VtnA","actions":"Note_actions__1Y6O7"};